module.exports = __webpack_public_path__ + "img/gris.aa4b9f71.png";